// src/utils/exportDoctorFee.ts
import ExcelJS from 'exceljs';
import { saveAs } from 'file-saver';
import moment from 'moment';

export async function exportDoctorFeeToExcel(
    rows: any[],
    t: any

) {
    const workbook = new ExcelJS.Workbook();
    const sheet = workbook.addWorksheet('Doctor Fee');

    // 1) กำหนดคอลัมน์ + header ของตาราง (row 2)
    sheet.columns = [
        { width: 6 },
        { width: 30 },
        { width: 15, style: { numFmt: '#,##0.00' } },
        { width: 15, style: { numFmt: '#,##0.00' } },
        { width: 12, style: { numFmt: '#,##0.00' } },
        { width: 25 },
        { width: 25 },
        { width: 20 },
    ];

    // 2) สร้าง Title (row 1)
    sheet.mergeCells('A1:H1');
    const titleCell = sheet.getCell('A1');
    titleCell.value = 'Doctor Fee Report';
    titleCell.font = { size: 16, bold: true };
    titleCell.alignment = { horizontal: 'center', vertical: 'middle' };
    sheet.getRow(1).height = 24;
    const headerRow = sheet.addRow([
        t('REPORT.TABLE.DOCTOR_FREE.NO'),
        t('REPORT.TABLE.DOCTOR_FREE.DENTIST'),
        t('REPORT.TABLE.DOCTOR_FREE.SERVICE_FEE'),
        t('REPORT.TABLE.DOCTOR_FREE.PAYMENT_FOR_TREATMENT'),
        t('REPORT.TABLE.DOCTOR_FREE.DF'),
        t('REPORT.TABLE.DOCTOR_FREE.BANK'),
        t('REPORT.TABLE.DOCTOR_FREE.ACCOUNT_NAME'),
        t('REPORT.TABLE.DOCTOR_FREE.ACCOUNT_NUMBER')
    ])
    headerRow.eachCell(cell => {
        cell.font = { bold: true }
        cell.alignment = { horizontal: 'center', vertical: 'middle' }
        cell.border = {
            top: { style: 'thin' },
            left: { style: 'thin' },
            bottom: { style: 'thin' },
            right: { style: 'thin' }
        }
    })

    // 4) ถ้าไม่มีข้อมูล ให้แสดงข้อความ “ไม่พบข้อมูล” ในแถวถัดมา (row 3) แล้วจบเลย
    if (!rows || rows.length === 0) {
        // merge A3:H3
        sheet.mergeCells('A3:H3');
        const noDataRow = sheet.getRow(3);
        noDataRow.getCell(1).value = 'ไม่พบข้อมูล';
        noDataRow.getCell(1).font = { italic: true };
        noDataRow.getCell(1).alignment = { horizontal: 'center' };
        // โหลดไฟล์เลย
        const buffer = await workbook.xlsx.writeBuffer();
        const blob = new Blob([buffer], {
            type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
        });
        const ts = moment().format('YYYYMMDD_HHmmss');
        saveAs(blob, `${t(`REPORT.REPORT_NAME.DOCTOR_FEE`)}_${ts}.xlsx`);
        return;
    }

    // 5) กรณีมีข้อมูล ให้ลูปเติม แต่ละ row เริ่มที่ row 3
    const startRow = 3;
    rows.forEach((r, idx) => {
        const rowIndex = startRow + idx;
        const row = sheet.getRow(rowIndex);

        // ดึงข้อมูล
        const doctorFullname = r.doctorFullname ?? '-';
        const total = r.total != null ? r.total : 0;
        const amountPaid = r.amountPaid != null ? r.amountPaid : 0;
        const dfNet = r.dfNet != null ? r.dfNet : 0;
        const bankName = r.bankName || '-';
        const bankAccountName = r.bankAccountName || '-';
        const bankAccountNumber = r.bankAccountNumber || '-';

        row.values = [
            idx + 1,
            doctorFullname,
            total,
            amountPaid,
            dfNet,
            bankName,
            bankAccountName,
            bankAccountNumber,
        ];

        // จัด alignment
        row.getCell(1).alignment = { horizontal: 'center' };
        [3, 4, 5].forEach(c => row.getCell(c).alignment = { horizontal: 'right' });
        [2, 6, 7, 8].forEach(c => row.getCell(c).alignment = { horizontal: 'left' });
    });

    // 6) สร้าง summary row ต่อท้าย
    const summaryRowIndex = startRow + rows.length;
    const summaryRow = sheet.getRow(summaryRowIndex);
    summaryRow.values = [
        '',                             // ลำดับเว้นว่าง
        'รวม',                          // คำว่า รวม
        { formula: `SUM(C${startRow}:C${summaryRowIndex - 1})` },
        { formula: `SUM(D${startRow}:D${summaryRowIndex - 1})` },
        { formula: `SUM(E${startRow}:E${summaryRowIndex - 1})` },
        '', '', ''
    ];
    summaryRow.font = { bold: true };
    summaryRow.getCell(2).alignment = { horizontal: 'left' };
    [3, 4, 5].forEach(c => summaryRow.getCell(c).alignment = { horizontal: 'right' });

    // 7) เขียน buffer → saveAs
    const buffer = await workbook.xlsx.writeBuffer();
    const blob = new Blob([buffer], {
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
    });
    const ts = moment().format('YYYYMMDD');
    saveAs(blob, `${t(`REPORT.REPORT_NAME.DOCTOR_FEE`)}_${ts}.xlsx`);
}
